import { api } from "../utils/AuthManager";

const PutClient = async (id, formData) => {
  return api
    .put(`/api/client/${id}/`, formData)

    .then((res) => {
      return res;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export default PutClient;
